export const addToastMessage = (res) => {
  if (!res || !(res instanceof Error)) return
  const err = res.response.data
  res.toast = 'Invalid response!'
  if (err.error) res.toast = err.error
  if (err.msg) res.toast = err.msg
  if (err.message) res.toast = err.message
  return res
}



// WEBPACK FOOTER //
// ./src/app/utils/toastErrorHandling.js